import type { PaletteOptions } from '@mui/material';

import type { ColorAliases } from 'src/theme/colors/aliases';
import type { BasicColors } from 'src/theme/colors/basic';

import type { ColorPalettes } from './colors';

export type Colors = ColorAliases & ColorPalettes & BasicColors;

export const themeColors = (colors: Colors): PaletteOptions => ({
  background: {
    grey: colors.neutral[100],
    selected: `${colors.black}0A`,
  },

  primary: {
    light: colors.primary[100],
    main: colors.primary[500],
    dark: colors.primary[700],
    contrastText: colors.white,
  },

  secondary: {
    light: colors.secondary[100],
    main: colors.secondary[500],
    dark: colors.secondary[700],
    contrastText: colors.black,
  },

  tertiary: {
    light: colors.neutral[200],
    main: colors.neutral[400],
    dark: colors.neutral[800],
    contrastText: colors.primary[500],
  },

  error: {
    light: colors.error[200],
    main: colors.error[500],
    dark: colors.error[700],
    contrastText: colors.white,
  },

  warning: {
    light: colors.warning[200],
    main: colors.warning[500],
    dark: colors.warning[700],
    contrastText: colors.white,
  },

  info: {
    light: colors.info[200],
    main: colors.info[500],
    dark: colors.info[700],
    contrastText: colors.white,
  },

  success: {
    light: colors.success[200],
    main: colors.success[500],
    dark: colors.success[700],
    contrastText: colors.white,
  },
});

export default themeColors;
